// MOCK DATA + FRONTEND-ONLY persistence (localStorage)
// NOTE: In the next step we can replace these helpers with real backend calls.

const LS_KEY = "cs_new_construction_leads_v1";

export const PROGRAM = {
  productName: "Residential + Commercial New Construction Loans",
  ratesStartingAt: "9.49%",
  loanToCost: "Up to 90% LTC",
  ficoMin: "680",
  loanAmountRange: "$200,000 to $30,000,000",
  term: {
    horizontal: "Up to 12 Months (Horizontal)",
    vertical: "Up to 12 Months (Vertical)",
  },
  drawRequests: {
    snap: "Snap Draws – funded in 24 hours",
    traditional: "Traditional Inspection – 3–5 days",
  },
  landAdvance: {
    permitted: "Up to 75% of land purchase price (if permitted)",
    notPermitted: "Up to 60% (if not permitted)",
  },
  closingTimeline: "2–4 weeks",
  eligibility: "Experienced developers only (similar-size completed projects in the last 3 years)",
  propertyTypes: [
    "Non-Owner Occupied Single Family Residential",
    "2–4 Units",
    "Townhomes",
    "10–100 Lot Residential Subdivisions",
    "Multifamily Apartments",
  ],
};

export const FAQS = [
  {
    q: "Who is this program designed for?",
    a: "Experienced developers with a recent track record of similar-size completed projects (on-time performance within the last 3 years).",
  },
  {
    q: "How fast can you close?",
    a: "Typical closing timeline is 2–4 weeks depending on documentation readiness, third-party reports, and underwriting complexity.",
  },
  {
    q: "How are construction costs funded?",
    a: "Up to 100% of construction costs can be funded (subject to underwriting) with total project funding up to 90% LTC.",
  },
  {
    q: "How do draw requests work?",
    a: "Choose Snap Draws (funded in ~24 hours) or Traditional Inspections (typically 3–5 days).",
  },
  {
    q: "What is the minimum credit score?",
    a: "Minimum FICO is 680.",
  },
];

export const PROPERTY_TYPE_OPTIONS = PROGRAM.propertyTypes.map((label) => ({
  label,
  value: label,
}));

export const TIMELINE_OPTIONS = [
  { label: "Immediately (0–30 days)", value: "0-30" },
  { label: "1–3 months", value: "1-3" },
  { label: "3–6 months", value: "3-6" },
  { label: "6+ months", value: "6+" },
];

export const LOAN_AMOUNT_OPTIONS = [
  { label: "$200K–$1M", value: "200k-1m" },
  { label: "$1M–$5M", value: "1m-5m" },
  { label: "$5M–$15M", value: "5m-15m" },
  { label: "$15M–$30M", value: "15m-30m" },
];

function safeParse(json, fallback) {
  try {
    return JSON.parse(json);
  } catch {
    return fallback;
  }
}

export function getLeads() {
  if (typeof window === "undefined") return [];
  const raw = window.localStorage.getItem(LS_KEY);
  const data = safeParse(raw || "[]", []);
  return Array.isArray(data) ? data : [];
}

export function createLead(lead) {
  // lead: { name, email, phone, company, propertyType, loanAmount, timeline, message }
  const now = new Date();
  const entry = {
    id: crypto?.randomUUID ? crypto.randomUUID() : String(now.getTime()),
    createdAt: now.toISOString(),
    ...lead,
  };

  const existing = getLeads();
  const updated = [entry, ...existing].slice(0, 250);
  window.localStorage.setItem(LS_KEY, JSON.stringify(updated));
  return entry;
}

export function clearLeads() {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(LS_KEY);
}
